import React, { useCallback, useContext } from 'react'
import SearchInputTrigger from '../SearchInputTrigger'
import styled from 'styled-components'
import { rem } from 'polished'
import DateInputValue from 'components/Search/SearchForm/SearchDateInput/DateInputValue'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import config from 'constants/config'

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-width: ${rem(300)};
  width: 100%;
  border: 1px solid ${({ theme }) => theme.palette.neutral.five};
  border-radius: ${props => props.theme.borderRadius.small};
  overflow: hidden;
  height: ${rem(50)};

  .no-border {
    border: none;
    border-radius: 0;
  }

  .border-right {
    border-right: 1px solid ${({ theme }) => theme.palette.neutral.five};
  }

  .search-input {
    background: ${({ theme }) => theme.palette.neutral.eight};
  }

  ${mediaQueryUp.sm} {
    width: auto;
  }
`

interface Props {
  onDateToggle: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isToggled: boolean;
  className?: string;
}

/**
 * UI component for Check in & Check out
 */
function DateSelectToggle({
  onDateToggle,
  isToggled,
  className,
}: Props) {
  const { checkinDate, checkoutDate } = useContext(GlobalSearchStateContext)
  /**
   * When click either date input box if the dropdown already toggled, keep it there
   */
  const handleClick = useCallback((e) => {
    if (!isToggled) {
      onDateToggle(e)
    }
  }, [isToggled, onDateToggle])

  const DATE_INPUT_PLACEHOLDER = config.businessTraveller.currentAccountMode === 'business' ? 'Select date' : 'Anytime'

  return (
    <InputContainer className={className}>
      <SearchInputTrigger
        onClick={handleClick}
        type="date"
        className="no-border border-right search-input">
        <DateInputValue dateValue={checkinDate} label="Check in" placeholder={DATE_INPUT_PLACEHOLDER}/>
      </SearchInputTrigger>
      <SearchInputTrigger
        onClick={handleClick}
        type="date"
        className="no-border search-input">
        <DateInputValue dateValue={checkoutDate} label="Check out" placeholder={DATE_INPUT_PLACEHOLDER}/>
      </SearchInputTrigger>
    </InputContainer>
  )
}

export default DateSelectToggle
